
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import CollapseItem from '@/components/collapse.vue';
	import UploadImg from '@/components/upload-img.vue';
	import quillconfig from '@/utils/quill-config';
	import Switch from '@/components/switch.vue'
  import {
    materialrelationProductItem,
    materialGroupNotesmaterialGroupNotesSave,
    materialGroupNotesmaterialGroupNotesInfo
  } from "@/api/material"
	import{
		getSearchDate,
		nextDay
	}from "@/utils/index"
  @Component({  
    name: '',
    components: {
      PageFooter,
      CollapseItem,
      UploadImg,
      'rt-switch':Switch
    }
  })

  export default class ProductList extends Vue {
    private form:any = {
      Id:0,
      GroupProductName:'',
      StartGroupTime:getSearchDate(2,false,1)[0],
      ProductId:'',
      CoverPicture:'',
      Content:'',
      Sort:'',
      IsShow:true,
      ShowTime:getSearchDate(2,true,1)[0]
    }
    private ProductIdList:any = []
    private editoroption:any = quillconfig


    private mounted () {
      if(Number(this.$route.query.Id)){
        this.getinfo()
      }else{
        this.getshopList()
      }
    }

    private testform(){
      let form = JSON.parse(JSON.stringify(this.form))
      if(!form.GroupProductName){
        this.$message.error('请输入团品名称')
        return false
      }
      if(!form.StartGroupTime){
        this.$message.error('请选择开团日期')
        return false
      }
      if(!form.CoverPicture){
        this.$message.error('请上传笔记封面图')
        return false
      }
      if(!form.Content){
        this.$message.error('请上传素材内容')
        return false
      }
      return true
    }
    private async save(){
      if(!this.testform()){
        return false
      }
      try{
        let data = JSON.parse(JSON.stringify(this.form))
        data.Sort = data.Sort || 0
        data.ShowTime = data.IsShow?data.ShowTime:''
        let res = await materialGroupNotesmaterialGroupNotesSave({Info:data})
        if(res.IsSuccess){
          this.$message.success('保存成功')
          this.goback()
        }
      }finally{
        //
      }
    }
    private goback(){
      this.$router.go(-1)
    }
    private uploadSuc(list){
      this.form.CoverPicture = list[0]
    }
    private async getshopList(){
      try{
        let res = await materialrelationProductItem({})
        if(res.IsSuccess){
          this.ProductIdList = res.Result
        }
      }finally{
        //
      }
    }
    private async getinfo(){
      try{
        let res = await materialGroupNotesmaterialGroupNotesInfo({
          Id:this.$route.query.Id
        })
        if(res.IsSuccess){
          this.form = res.Result
          await this.getshopList()
          // console.log(this.form.ProductId)
          if(this.form.ProductId==0){
            this.form.ProductId = ''
          }else if(!this.ProductIdList.find(v=>v.Id==this.form.ProductId)?.Id){
            this.ProductIdList.push({
              Id:this.form.ProductId,
              ProductName:this.form.ProductName,
            })
          }
        }
      }finally{
        //
      }
    }
  }
